// extracted by mini-css-extract-plugin
export default {"title":"mu6pL","body":"mBWrF","container":"s3CWh"};